import { GameData } from '../../server/data/GameData';
import { Presentation } from "../../../core/gameflow/controller/Presentation";
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { SanQuentin2 } from '../../SanQuentin2';
import { RevealerManager } from '../../modules/revealer/RevealerManager';
import { StateHandler } from '../../../core/utils/StateHandler';
import { ZeroBetPresentation } from '../../zero/ZeroBetPresentation';
import { SanEngineManager } from '../../engine/SanEngineManager';
import { SplashWindows } from '../../modules/splashScreen/SplashWindows';
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { SanGameMode } from '../../config/base/GameConfig';
import { IntroPresentation } from '../features/intro/IntroPresentation';

enum ModeTransitionState {
    INTRO_PRES,
    TRANSIT_INTRO,
    INTRO_CONV,
    TRANSIT_OUTRO,
    OUTRO
}

export class ModeTriggerPresentation extends Presentation {

    private nextMode: string = "";

    protected playIntroRestore: boolean = false;
    protected scatterPos: number[];
    protected amountOfSkulls: number = 0;

    protected choiceValue:number = 0;

    private state = new StateHandler(undefined, new Map<number, Function >([
        [ModeTransitionState.INTRO_PRES, () => this.FreeSpinWonWindow()],
        [ModeTransitionState.TRANSIT_INTRO, () => this.TransitToSetup()],
        [ModeTransitionState.INTRO_CONV, () => this.onConv()],
        [ModeTransitionState.TRANSIT_OUTRO, () => this.onOutroTransit()],
        [ModeTransitionState.OUTRO, () => this.Outro()],
    ]));

    public checkForActivation(data: GameData): boolean {
        return data.gameModeChanges && !data.Win.brokeTheBank;
    }

    setGameData(data: GameData): void {
        super.setGameData(data);

        this.nextMode = data.nextMode;
        
        if(this.nextMode === SanGameMode.FREESPIN_SETUP1 ){
            SanQuentin2.setupPhase.setData(data);
            this.state.set(ModeTransitionState.INTRO_CONV)
        } 
        else if(this.nextMode === SanGameMode.NORMAL ) this.state.set(ModeTransitionState.OUTRO)
        else this.setPlayable(false);
        this.scatterPos = data.Reel.scatterPositions;
    }

    public preStart(): void {
        ZeroBetPresentation.pickedZeroValue = 0;
    }

    public createPresentation(enableSkip: Function) {
        enableSkip(false);

        if (SanQuentin2.counter.timeRemaining) {
            this.timeline.to(this, { duration: SanQuentin2.counter.timeRemaining });
            return;
        }

        this.state.triggerState(enableSkip);
    }

    onConv(): void {
        SoundManager.playSoundEffect(SoundConfig.FS_START_RIFF);
        SanEngineManager.RAll((reel) => {
            this.timeline.add(reel.reelLocker(true), 0);
        });
        this.state.set(ModeTransitionState.INTRO_PRES);
    }

    FreeSpinWonWindow(): void {
        RevealerManager.getAllBars().forEach(bar => {
            bar.shuffle(false)
        });

        SlotGame.keypadPlugin.setWin(this._gameData.Win!.totalWin, 
            true,
            this._gameData.Win.isWinBelowStake!());
        SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
        this.timeline.add(SanQuentin2.splashController.play({
            view: SplashWindows.FREESPIN,
            ctnBtnFunc: () => { 
                this.skip();
                SoundManager.playSoundEffect(SoundConfig.FS_START_INTRO_GAMBLING);

             },
            data: this._gameData,
        }));
        this.state.set(ModeTransitionState.TRANSIT_INTRO);
    }

    TransitToSetup(): void {

        SanQuentin2.background.triggerTransition(true);
        SanQuentin2.reelEngineManager.ZoomIn(true,0.75);
        SanQuentin2.xWaysCounter.counterActive(false, !this._gameData.isNormalMode);
        SoundManager.stopSoundEffect(SoundConfig.BASE_GAME_AMBIANCE);
        SoundManager.PlayAmbience(SoundConfig.FS_INTRO_AMBIANCE);
        SanQuentin2.background.setBgGFX(1,1.5)
        this.timeline.add(SanQuentin2.setupPhase.playIntro(),0.75);

        this.setPlayable(false);
    }

    Outro():void {
        SanEngineManager.RSAll((rc, sym) => { sym.stopWin(0.2) })
        SanQuentin2.background.showRedLight(false);
        this.timeline.add(SanQuentin2.splashController.play({
            view: SplashWindows.OUTRO,
            ctnBtnFunc: () => { SoundManager.PlayAmbience(SoundConfig.BASE_GAME_AMBIANCE); this.skip(); },
            data: this._gameData,
        }),0);

        if(!this._gameData.Win.isWinBelowStake())
            SoundManager.playSoundEffect(SoundConfig.FS_ENDS);
  

        SlotGame.keypadPlugin.setZeroBetSpinCounter(-1)
        this.state.set(ModeTransitionState.TRANSIT_OUTRO);
    }

    onOutroTransit():void {
        this.setPlayable(false);
        SanQuentin2.reelEngineManager.returnToBase();
        IntroPresentation.playIntroAnimation(this.timeline);
        SanQuentin2.background.triggerTransition(false);
        SanQuentin2.jumpingWildController.CleanAndReset();
        RevealerManager.setSpecialData("",0);
        SanQuentin2.xWaysCounter.hide();
        SanQuentin2.overlay.hideLogo();
        SoundManager.playSoundEffect(SoundConfig.FS_OUTRO_BUSS);
        this.timeline.add(() => { 
            SanQuentin2.xWaysCounter.counterActive(true,false);
            SanQuentin2.overlay.introApplyLogo();
        })
    }

    skip(): void {
        super.skip();
    }

    done(): void {
        
        // Speedster.playText("Choice Value : " + this.choiceValue.toString(),2);
    }
}